import { WhiteboardsKeyType } from '../../keys';

const whiteboardsKeys: WhiteboardsKeyType = {
  canNotDeterminatePage: 'Can not determinate page',
  changesWontBeSavedUntilTheConnectionIsRestoredPleaseWaitAMomentWhileWeTryToReconnect:
    'Changes won’t be saved until the connection is restored. Please wait a moment while we try to reconnect.',
  comments: 'Comments',
  commentTagComposition: 'Composition',
  commentTagDefault: 'Default',
  commentTagGeometry: 'Geometry',
  commentTagLighting: 'Lighting',
  commentTagMaterial: 'Material',
  commentTagTexture: 'Texture',
  connectionLost: 'Connection lost.',
  connectionLostTryingToReconnect: 'Connection lost. Trying to reconnect...',
  connectionSuccessfullyRestored: 'Connection successfully restored',
  couldNotRestoreTheConnection: 'Could not restore the connection',
  couldNotLoadWhiteboard: 'Could not load the whiteboard. Please try again.',
  createMissingShapes: 'Create missing shapes',
  deleteEvents: 'Delete events',
  draftCommentIsNotVisibleToOtherProjectMembersUntilItIsPublished:
    'Draft comment is not visible to other project members until it is published',
  draftCommentNotVisibleToOthers:
    'non-empty draft comment — not visible to others',
  draftCommentsNotVisibleToOthers:
    'non-empty draft comments — not visible to others',
  addFileNamesAboveEachImage: 'Add file names above each image',
  filterComments: 'Filter comments',
  goTo: 'Go to whiteboard',
  goToWhiteboardAfterSending: 'Go to whiteboard after sending',
  imageAlreadyAttachedToThisTask: 'Image already attached to this task',
  inProgress: 'In progress',
  limits: 'Limits',
  markAsInProgress: 'Mark as In progress',
  markAsResolved: 'Mark as Resolved',
  markAsUnresolved: 'Mark as unresolved',
  newImagesVisibility: 'New images visibility',
  noCommentsFound: 'No comments found',
  open: 'Open in whiteboard',
  page: 'Page',
  pageName: 'Page name',
  pagesOnThisWhiteboard: 'Pages on this whiteboard',
  pleaseSelectAnImage: 'Please, select an image',
  preview: 'Preview',
  project: 'Project whiteboard',
  publishAll: 'Publish all',
  publishedCommentIsVisibleToAllProjectMembers:
    'Published comment is visible to all project members',
  records: 'records',
  resolved: 'Resolved',
  rootProjectWhiteboard: 'Root project whiteboard',
  saveDraft: 'Save draft',
  select: 'Select whiteboard',
  selectPage: 'Select page',
  sendAndStay: 'Send and stay',
  setInProgress: 'Set in progress',
  shapesOnThisPage: 'Shapes on this page',
  showInProgressComments: 'Show in progress',
  showResolvedComments: 'Show resolved',
  sendToTask: 'Send to task',
  sentToWhiteboard: 'Sent to whiteboard',
  shapes: 'Shapes',
  singularLowerCase: 'whiteboard',
  task: 'Task whiteboard',
  thereIsNoMissingShapes: 'There is no missing shapes',
  unsetInProgress: 'Unset in progress',
  updateEventDate: 'Update event date',
  youHaveUsedAllPagesQuota: 'You have used all pages quota.',
  youHaveUsedAllShapesQuota: 'You have used all shapes quota.',
  whiteboardBackups: 'Whiteboard backups',
  whiteboardComments: 'Whiteboard comments',
  whiteboardImages: 'Whiteboard images',
  whiteboardDeleteEvents: 'Whiteboard delete events',
  whiteboardIsExportingToPdf: 'Whiteboard is exporting to PDF..',
  whiteboardRoomFull:
    'This whiteboard has reached its connection limit. Close extra tabs with this whiteboard open, then try again.',
  wouldYouLikeToBeRedirectedToTheWhiteboard:
    'Would you like to be redirected to the whiteboard?',
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  zoomTo100: 'Zoom to 100%',
  zoomToFit: 'Zoom to fit',
  zoomToSelection: 'Zoom to selection'
};

export default whiteboardsKeys;
